export const GlobalPaginationSize = {
	CMPaginationSize: 50,
	AdminPaginationSize: 200,
	defaultPaginationSize: 50,
};

export const getPaginationSizeOnRole = (empDesignation) => {
	debugger
	if (empDesignation.toString() === "4") {
		return GlobalPaginationSize.CMPaginationSize;
	}
	else if (empDesignation.toString() === "96") {
		return GlobalPaginationSize.AdminPaginationSize;
	}
	else return GlobalPaginationSize.defaultPaginationSize;
};
